export const NextSvg = () => {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.68994 5.12695L12.8165 10.2535L7.68994 15.3801" stroke="currentColor" strokeWidth="1.70886"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
